import { SiteAnnouncement } from 'core/siteAnnouncement/SiteAnnouncement';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFile } from '@fortawesome/free-regular-svg-icons';
import styles from './siteAnnouncementMediaColumns.module.scss';
import { downloadFromUrl, getFileNameFromUrl } from 'utils/DownloadUtils';

export const SiteAnnouncementImageColumn: React.FC<{
  announcement: SiteAnnouncement;
}> = ({ announcement }) => {
  if (!announcement.imageUrl) {
    return (
      <div className={`${styles.imageEmpty} ${styles.emptyPlaceholder}`}>-</div>
    );
  }
  return (
    <img
      className={styles.thumbnail}
      src={announcement.imageUrl}
      alt={getFileNameFromUrl(announcement.imageUrl)}
    />
  );
};

export const SiteAnnouncementAttachmentsColumn: React.FC<{
  announcement: SiteAnnouncement;
}> = ({ announcement }) => {
  const attachmentUrls = announcement.attachmentUrls || [];
  if (attachmentUrls.length === 0) {
    return <div className={styles.emptyPlaceholder}>-</div>;
  }
  return (
    <div className={styles.attachments}>
      {attachmentUrls.map((attachmentUrl) => (
        <button
          key={attachmentUrl}
          type='button'
          className={styles.attachment}
          onClick={(event) => {
            event.stopPropagation();
            downloadFromUrl(attachmentUrl);
          }}
        >
          <FontAwesomeIcon className={styles.attachmentIcon} icon={faFile} />
          <span className={styles.attachmentName}>
            {getFileNameFromUrl(attachmentUrl)}
          </span>
        </button>
      ))}
    </div>
  );
};

export const renderSiteAnnouncementImageColumn = (
  announcement: SiteAnnouncement
) => {
  return <SiteAnnouncementImageColumn announcement={announcement} />;
};

export const renderSiteAnnouncementAttachmentsColumn = (
  announcement: SiteAnnouncement
) => {
  return <SiteAnnouncementAttachmentsColumn announcement={announcement} />;
};
